import { AttendanceService } from '@gtpl/shared-services/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployeeLeavesModule } from '../employee-leaves/employee-leaves.module';
import { EmployeeLeavesRepository } from '../employee-leaves/entity/employee-leaves.repository';
import { TypesOfLeavesRepository } from '../types-of-leaves/repo/types-of-leaves.repository';
import { TypesOfLeavesModule } from '../types-of-leaves/types-of-leaves.module';
import { TypesOfLeavesService } from '../types-of-leaves/types-of-leaves.service';
import { ApplyForLeavesController } from './apply-for-leaves.controller';
import { ApplyForLeavesService } from './apply-for-leaves.service';
import { ApplyForLeavesAdapter } from './dto/apply-for-leaves.adapter';
import { ApplyForLeavesRepository } from './repository/apply-for-leaves.repository';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([ApplyForLeavesRepository, EmployeeLeavesRepository, TypesOfLeavesRepository]),
    forwardRef(() => TypesOfLeavesModule),
    forwardRef(() => EmployeeLeavesModule),
  ],
  controllers: [ApplyForLeavesController],
  providers: [ApplyForLeavesService, ApplyForLeavesAdapter, ApplicationExceptionHandler, TypesOfLeavesService, AttendanceService,WhatsappBroadCastService,LogsService],
  exports: [ApplyForLeavesService]
})
export class ApplyForLeavesModule { }
